import { Component, Input, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ActiveOrder } from '../../../../classes/active.order';
import { UserService } from '../../../../service/user.service';
import { DeliveryService } from '../../../../service/delivery.service';
import { ActiveOrderService } from '../../../../service/active.order.service';
import { NumberFormatPipe } from '../../../../pipes/number.format.pipe';
import { CustomDatePipe } from '../../../../pipes/custom.date.pipe';

/**
 * Uses an attribute selector since the extra element will destroy the table otherwise
 */
@Component({
    selector: '[pending-order-row]',
    templateUrl: 'pending.order.row.component.html',
    standalone: true,
    imports: [RouterLink, CustomDatePipe, NumberFormatPipe]
})
export class PendingOrderRowComponent implements OnInit {
  private userService = inject(UserService);
  private activeOrderService = inject(ActiveOrderService);
  private deliveryService = inject(DeliveryService);
  private router = inject(Router);

  @Input() activeOrder: ActiveOrder;
  @Input() closingInDay: string;
  @Input() closingInDays: string;
  @Input() closingTomorrow: string;
  @Input() closed: string;
  @Input() closedIn: string;

  renderedClosingTime: string;
  closingInHours: number;

  ngOnInit() {
    if (this.activeOrder.closingTime) {
      this.closingInHours = this.deliveryService.getClosingInHours(this.activeOrder.closingTime);
      this.renderedClosingTime = this.deliveryService.getClosingTimeString(
        this.activeOrder.closingTime,
        this.activeOrder.closingHour,
        this.closingInHours,
        this.closingInDay,
        this.closingInDays,
        this.closingTomorrow,
        this.closed,
        this.closedIn
      );
    }
  }

  public showAddProducts(): boolean {
    if (this.userService.isUseFastCheckout()) {
      return this.closingInHours > 0 && this.activeOrder.addProductsAllowed;
    }

    return false;
  }

  public addProducts(activeOrder: ActiveOrder) {
    this.activeOrderService.setSelectedOrder(activeOrder);
    this.router.navigate(['/products']);
  }
}
